export default __webpack_public_path__ + "static/media/handelsbanken.1c8c0d36.png";